enum COMMON_STATUS {
  CREATED = 'created',
  LAST_UPDATED = 'updated',
}

export { COMMON_STATUS };
